import React, { type FC } from 'react'

import { useIntl } from 'react-intl'
import { useRecoilCallback } from 'recoil'

import {
  Flex,
  LINK_VARIANT_DEFAULT,
  Link,
  TITLE_VARIANT_XL,
  Title,
} from 'mailup-web-components'

import IconChevronsRight from 'Components/icons/IconChevronsRight'

import { panelAddRecipientCloseCallback } from 'Pages/RecipientsList/recoil/callbacks/addRecipient'

const PanelAddRecipientHeader: FC = () => {
  const intl = useIntl()

  const handleClose = useRecoilCallback(panelAddRecipientCloseCallback, [])

  return (
    <Flex flexDirection="column" gap="16px">
      <Flex alignItems="center" gap="16px">
        <Link
          variant={LINK_VARIANT_DEFAULT}
          onClick={handleClose}
          data-mu-test="close-side-panel"
          data-tip={intl.formatMessage({
            id: 'Load.RecipientsList.PanelCloseTooltip',
          })}
        >
          <IconChevronsRight width="14px" height="14px" />
        </Link>
      </Flex>

      <Title variant={TITLE_VARIANT_XL} overflowWrap="anywhere">
        {intl.formatMessage({ id: 'Load.RecipientsList.ActionAddRecipient' })}
      </Title>
    </Flex>
  )
}

export default PanelAddRecipientHeader
